//Tirar bin/console fos:js-routing:dump --format=json --target=js_es6/fos_js_routes.json para actualizar las rutas
const routes = require('../../fos_js_routes.json');
import Routing from '../../../vendor/friendsofsymfony/jsrouting-bundle/Resources/public/js/router'

import './foros.scss';
/**
 * Librería de gestión de comentario en el frontal del sitio.
 *
 * Se encarga de la captura, renderización de comentarios así como de la posibilidad
 * de respuesta (dependiendo de si es un usuario logueado) y la denuncia de los mismos.
 *
 * La librería no requiere parámetros de iniciación para los comentarios embebidos en otros
 * recursos (noticias y cotizaciones), ya que leerá dichos datos del elemento del DOM con el
 * atributo data-comments="true". Dicho elemento además llevará un atributo data-category
 * para la categoría asociada al recurso en el que se embebe y data-id para el el id de recurso
 * (id de noticia o id de instrumento).
 *
 */

export const loadForos = () => {
    Routing.setRoutingData(routes);
    return $(function(){
        core();
        loadEmbeddedComents();
    });
}

const CONST_LOADER = '<div class="bigLoader"><div class="loader"></div></div>';
const CONST_SMALL_LOADER = '<span class="opt-load"></span>';

const loadEmbeddedComents = () => {
    //Comprobar si hay un bloque de comentarios
    if ($('[data-comments="true"]').length > 0) {
        var refreshCount = false;
        if ($('[data-comments="true"]').data('category') === 'noticias') {
            refreshCount = true;

            $('body').on('click', '.comment-click', function(e) {
                e.preventDefault();
                var href = $.attr(this, 'href');

                $('html, body').animate({scrollTop: $(href).offset().top - 90}, 2000);
            });

        } else {
            $('a#foroTab').on('click', function(){
                window.location.hash = 'comments';
            });
        }

        _callbackAfterComment = function() {
            _reloadCommentList(refreshCount);
        };

        _reloadCommentList(refreshCount);
    }
}


//Callback para las acciones de insertar comentarios
//Para comentarios embebidos esta variable se sobreescribe
let _callbackAfterComment = function() {
    location.href = location.href.replace(location.pathname, location.pathname.split(/\/[0-9]+$/)[0]);
}

const _refreshCommentCount = function(count) {
    //Si tiene page kicker entonces se trata de una noticia y por lo tanto actualizamos
    //el contador de comentarios
    if ($('.page-kicker').length > 0) {
        var title;
        if (count > 0){
            title =  count === 1 ? '1 comentario' : count + ' comentarios';
        }else{
            title = 'Sin comentarios';
        }
        var $kicker = $('<span/>', {'class': 'kicker'}).append([
            $('<span/>', {'class': 'icon-tool-3'}),
            $('<a class="lnk lnk-comments-1 comment-click" title="'+title+'" href="#comentarios">'+count+'</a>')
        ]);
        var $selector = $('.page-kicker > .kicker');
        if($selector.length > 0){
            //Existe el selector. Lo reemplazamos para actualizar el contenido.
            $selector.replaceWith($kicker);
        }else{
            //No existe el selector. Lo añadimos antes del contenido del page kicker
            $('.page-kicker').prepend($kicker);
        }
    }
};

//Actualiza por AJAX la lista de comentarios del foro asociados a un recurso y que se muestran
//embebidos en la página del recurso (detalle de la noticia o ficha de la cotización)
const _reloadCommentList = function(refreshCount) {
    var $target = $('[data-comments="true"]');
    if ($target.length > 0) {
        var category = $target.data('category');
        var id = $target.data('id');
        $.ajax({
            url: Routing.generate('forum_embedded_comments', {'category': category, 'id': id}),
            beforeSend: function() {
                $target.find('.comment').remove();
                $target.find('.comments').remove();
                $target
                    .append($(CONST_LOADER).hide().fadeIn(800));
            }
        })
        .done(function (data) {
            if (refreshCount) {
                _refreshCommentCount(data.count);
            }

            $target.find('.bigLoader').fadeOut(800, function() {
                $(this).remove();
                $target.append($(data.html).hide().fadeIn(800));
                var $headband = $target.find('.headband').first();
                if (data.urlTopic && !($headband.find('a.lnk.lnk-more').length > 0)) {
                    $($headband).append([
                        $('<a class="lnk lnk-more" title="Continua leyendo y participando en el foro" href="'+data.urlTopic+'">Seguir en el foro</a>')
                    ]);
                }
            });

        })
        .fail(function (jqXHR) {
            $target.find('.bigLoader').fadeOut(800, function() {
                $(this).remove();
                $target.append($('<div/>').html(jqXHR.responseJSON).hide().fadeIn(800));
            });
        });
    }
}


const core = () => {
    //Muestra el popup de logado
    const _showLightbox = function() {
        var lightbox = lity();
        lightbox('#registration-modal');
    };

    const _showSmallLoader = function(handler) {
        if (handler.closest('.comment-actions').next().children().length > 0) {
            handler.closest('.comment-actions').next().fadeOut(800);
        }
        handler.closest('.comment-actions').append(CONST_SMALL_LOADER);
    };

    const _hideSmallLoader = function(handler, html) {
        if (handler.closest('.comment-actions').next().length > 0) {
            handler.closest('.comment-actions').next().html(html).fadeIn(800);
        } else {
            handler.closest('.comment-actions').after($('<div/>').html(html).fadeIn(800));
        }
        handler.closest('.comment-actions').find('.opt-load').remove();
    };

    Routing.setRoutingData(routes);

    /*###############################################################################################
    ######################### EJECUCIÓN DE EVENTOS ####################################################
    ###############################################################################################*/
    $('body').on('click', "#new-topic-button", function() {
        var $this = $(this);
        var $target = $this.closest('.new-topic');
        $.ajax({
            type: 'POST',
            url: Routing.generate('forum_topic_create'),
            beforeSend: function() {
                $this.remove();
                $target.append($(CONST_LOADER).hide().fadeIn(800));
            }
        })
            .done(function (html) {
                $target.find('.bigLoader').fadeOut(800, function() {
                    $(this).remove();
                    $target.append(html).hide().fadeIn(800);
                });
            })
            .fail(function (jqXHR) {
                if(jqXHR.status === 401) {
                    $target.find('.bigLoader').fadeOut(800, function() {
                        $(this).remove();
                        $target.append($this).hide().fadeIn(800);
                    });
                    _showLightbox();
                } else {
                    $this.remove();
                    $target.find('.bigLoader').fadeOut(800, function () {
                        $(this).remove();
                        $target.append($('<span/>').html(jqXHR.responseJSON).hide().fadeIn(800));
                    });
                }
            });
    });

    $('body').on('click', ".opt-comment, .opt-reply", function (e) {
        e.preventDefault();
        var $this = $(this);
        var target = $this.data('target');
        var route = $this.hasClass('opt-reply') ? 'forum_reply_comment' : 'forum_comment';
        $.ajax({
            type: 'POST',
            url: Routing.generate(route, {'hash': target}),
            beforeSend: function() { _showSmallLoader($this); }
        })
            .done(function (html) {
                _hideSmallLoader($this, html);
            })
            .fail(function (jqXHR) {
                if(jqXHR.status === 401) {
                    _showLightbox();
                    $this.closest('.comment-actions').find('.opt-load').remove();
                } else {
                    _hideSmallLoader($this, jqXHR.responseJSON);
                }
            })
    });

    $('body').on('click', ".opt-report", function (e) {
        e.preventDefault();
        var $this = $(this);
        var target = $this.data('target');
        $.ajax({
            type: 'POST',
            url: Routing.generate('forum_report_comment', {'hash': target}),
            beforeSend: function() { _showSmallLoader($this); }
        })
            .done(function () {
                $this.closest('.comment-actions').find('.opt-load').remove();
                $this.remove();
            })
            .fail(function (jqXHR) {
                if(jqXHR.status === 401) {
                    _showLightbox();
                    $this.closest('.comment-actions').find('.opt-load').remove();
                } else {
                    _hideSmallLoader($this, jqXHR.responseJSON);
                }
            })
    });

    $('body').on('submit', '.form-topic, .form-comment, .form-reply', function (e) {
        e.preventDefault();
        var $form = $(this);
        var buttonLabel = $form.find('[type="submit"] > span.text').html();
        $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize(),
            beforeSend: function() {
                $form.find('[type="submit"] > span.text').html('Enviando...');
            }
        })
            .done(function () {
                _callbackAfterComment();
            })
            .fail(function (jqXHR) {
                if(jqXHR.status === 401) {
                    _showLightbox();
                    $form.find('[type="submit"] > span.text').html(buttonLabel);
                } else {
                    $form.replaceWith(jqXHR.responseJSON);
                }
            })
    });
}
